import './styles/css/cmsMainStyle.css'
import React, {Fragment} from 'react'
import Apps from './components/App'

const App = () => {
	return (
		<Fragment>
			<Apps />
		</Fragment>
	)
}

export default App
